import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Separator } from '@swyftx/aviary/atoms/Seperator/Seperator';
import { Body, Numeric } from '@swyftx/aviary/atoms/Typography';
import { ReviewItem } from '@swyftx/aviary/molecules/ReviewItem/ReviewItem';
import { ProtectionOrderVariant } from '@swyftx/margin/build/types';

import { formatCurrency } from '@shared/utils';

type Props = {
  title: string;
  protectionOrderVariant: ProtectionOrderVariant;
  value: string;
};

const MarginTradeReviewProtectionOrder: React.FC<PropsWithChildren<Props>> = ({
  title,
  value,
  protectionOrderVariant,
  children,
}) => {
  const { t } = useTranslation('margin');

  return (
    <FlexLayout direction='column' spacing={12}>
      <Separator className='w-full' />
      <Body size='xsmall' weight='emphasis' color='primary'>
        {t('tradeReview.linkedProtectionOrder')}
      </Body>
      <ReviewItem title={`${title} price`}>
        <Numeric weight='bold'>≈ {formatCurrency(value)}</Numeric>
      </ReviewItem>
      <ReviewItem
        underline='dashed'
        tooltip={
          protectionOrderVariant === ProtectionOrderVariant.TakeProfit
            ? t('position.estimatedProfit.tooltip')
            : t('position.estimatedLoss.tooltip')
        }
        title={
          protectionOrderVariant === ProtectionOrderVariant.TakeProfit
            ? t('tradeReview.estimatedProfit')
            : t('tradeReview.estimatedLoss')
        }
      >
        {children}
      </ReviewItem>
    </FlexLayout>
  );
};

export { MarginTradeReviewProtectionOrder };
